import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';

import { PagesRoutingModule } from './pages-routing.module';
import { PagesComponent } from './pages.component';
import { SharedModule } from '../shared/shared.module';
import { MainHomePageComponent } from './main-home-page/main-home-page.component';
import { SwigitBundleComponent } from './swigit-bundle/swigit-bundle.component';
import { SpinnerModule } from './spinner/spinner.module';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { MyPaymentHistoryComponent } from './my-payment-history/my-payment-history.component';
import { DomainHomePageComponent } from './domain-home-page/domain-home-page.component';
@NgModule({
  declarations: [PagesComponent, MainHomePageComponent, SwigitBundleComponent, MyProfileComponent, MyPaymentHistoryComponent, DomainHomePageComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SpinnerModule,
    RouterModule,
    PagesRoutingModule,
    SharedModule,
    NgSelectModule
  ],
  exports:[
    NgSelectModule
  ],
})
export class PagesModule { }
